module.exports = __webpack_public_path__ + "static/media/en.b15630bc.png";